module.exports = __webpack_public_path__ + "static/media/blog-35-img2.3cc57df4.webp";